import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from "@mui/material";
import Axios from "axios";
import { useState } from "react";
import getCookie from "../../utils/getCookies";

export default function ConfirmModal({ data, open, onClose, onSuccess, onError}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    const response = await Axios.post(`${process.env.REACT_APP_URL}/api/v1/makeup/manual`, {
      course_id: data.course_id,
      event_id: data.event_id,
      teacher_id: data.teacher_id,
      teacher_email: data.teacher_email,
      allow_sunday: data.allow_sunday,
    },{
      headers: {
        Authorization: `Bearer ${getCookie('_auth')}`,
      },
    })
    if (response.status === 200){
      setIsLoading(false);
      onSuccess();
    } else{
      setIsLoading(false);
      onError();
    }
  }
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 'bold' }} variant="h5" color="error">Danger Zone</DialogTitle>
      <DialogContent>
        <Typography variant="h6">
          You are about to initiate a manual makeup loop for the following course.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained" color="error" disabled={isLoading}>
          {isLoading ? <CircularProgress size={20} /> : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}